import { useParams } from 'react-router';

export const useNewId = () => {
  const { id } = useParams<{ id: string }>();
  return { id, isNew: id === 'new' };
};
